<div class="col-sm-12" *ngIf="facilityConfig.schedule.template == 'default' || facilityConfig.schedule.template == 'compact'">
  <div class="row g-0 mb-3 upcoming" (click)="goToSession()">
    <div class="col-6">
      <img [src]="studioLogo" class="studio-logo" [alt]="studioName">
      <p class=""><small class="text-body-secondary text-muted">{{className}}</small></p>
    </div>
    <div class="col-6">
      <div class="">{{classStartDate()}}</div>
      <div class="">{{classStartTime()}}</div>
    </div>
  </div>
</div>

<div class="col-sm-12" *ngIf="facilityConfig.schedule.template == 'instructor'">
  <div class="row g-0 mb-3 upcoming" (click)="goToSession()">
    <div class="col-6">
      <p style="margin: 0; font-size: 18px; color: #000;"><small class="text-body-secondary text-muted">{{className}}</small></p>
      <p style="font-size: 16px;"><small class="text-body-secondary text-muted">{{instructorName}}</small></p>
    </div>
    <div class="col-6">
      <div class="">{{classStartDate()}}</div>
      <div class="">{{classStartTime()}}</div>
    </div>
  </div>
</div>